<template>
  <BasicLayout :left="left" :middle="middle" :right="right">
    <template v-slot:right_view>
      <div class="h-toolbarBg">
        <ejs-toolbar :items="toolbarItems"></ejs-toolbar>
        <div class='h-inputBox'>
          <ejs-textbox v-model='keyword' :placeholder='$t("Security.User.username")' @keyup.enter.native="filterAccount" maxLength='20'></ejs-textbox>
        </div>
      </div>
      <div class="h100-80 h-scroll">
        <ejs-grid :dataSource="accountOperateData" :allowPaging="false" ref="grid"  :height="screenHeight">
          <e-columns>
            <e-column field="userId" :visible="false"></e-column>
            <e-column field="username" :headerText="$t('Security.User.username')" width="120" textAlign="Center"></e-column>
            <e-column field="operateCount" :headerText="$t('Security.User.operateCount')" width="120" textAlign="Center"></e-column>
            <e-column field="operateTime" :headerText="operateTime" width="120" textAlign="Center"></e-column>
          </e-columns>
        </ejs-grid>
      </div>
    </template>
  </BasicLayout>
</template>
<script>
import BasicLayout from '../../layouts/BasicLayout';
import CustomDialog from '../../components/common/CustomDialog';

export default {
  name: 'accountOperateCalc',
  data() {
    return {
      accountOperateData: [],
      left: { show: false, name: '' },
      middle: { show: false, name: '' },
      right: { show: true, crumb: `${this.$t('Security.securityManage')}`+'/' + `${this.$t('Security.authorityManage')}` + '/' + `${this.$t('Security.operateCalc')}` },
      toolbarItems: [
        { prefixIcon: 'icon hero-icon hero-icon-refresh', tooltipText: this.$t('Alarm.refresh'), click: this.refreshGrid }
      ],
      keyword: '',
      operateTime: `${this.$t('Security.User.operateTime')}`+'('+`${this.$t('Common.minute')}`+')',
      screenHeight: document.body.clientHeight - 240
    };
  },
  components: {
    BasicLayout,
    CustomDialog,
  },
  mounted() {
    this.getAccountOperateList();
    let That = this;
    window.onresize = () => {
      return (() => {
        That.screenHeight = document.body.clientHeight - 240;
      })()
    }
  },
  methods: {
    getAccountOperateList() {
      const url = '/lte/ems/user/queryUserOperateCalc';
      const params = { params: {
        username: this.keyword
      } };
      const That = this;
      this.axios.get(url, params).then(response => {
        const result = response.data;
        That.accountOperateData = result;
      });
    },
    filterAccount() {
      this.getAccountOperateList();
    },
    getRecord() {
      const result = this.$refs.grid.getSelectedRecords();
      if (result === null || result === '') {
        this.$parent.showToast('warning',`${this.$t('Common.tips.noSelect')}`);
        return null;
      }
      return result;
    },
    refreshGrid() {
      this.getAccountOperateList();
    }
  },
  watch: {
    screenHeight(val) {
      this.screenHeight = val;
    }
  }
};
</script>
